<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
   <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="categorieArticleForm" @submit="addCategorieArticle" :validation-schema="categorieArticleSchema" >
            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom <span class="text-danger">*</span>
                  </label>
                  <Field name="nom" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nom"/>
                  <ErrorMessage name="nom" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Type de Service
                  </label>
                  <Field  name="typeCategorie" v-model="typeDefault"  v-slot="{ field }">
                    <Multiselect
                      :options="typeCategorieOptions"
                      :searchable="true"
                      track-by="label"
                      label="label"
                      v-model = "field.value"
                      v-bind = "field"
                      placeholder="Sélectionner le type de service"
                    />
                  </Field>  
                  <ErrorMessage name="typeCategorie" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-4" >
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      Lien
                    </label>
                    <Field name="lienExterne" type="text" ref="" placeholder="Entrer le lien"  class="form-control shadow-none rounded-0 text-black" />
                    <ErrorMessage name="lienExterne" class="text-danger"/>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">
                    Coût
                  </label>
                  <Field name="cout" type="text" 
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le coût" min="0" oninput="this.value = this.value.replace(/[^0-9]/g, '')"/>
                    <ErrorMessage name="cout" class="text-danger"/>
                </div>
                
              <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Sous service
                </label>
                <Field  name="categorieArticle" v-slot="{ field }">
                  <Multiselect
                    :options="categorieOptions"
                    :searchable="true"
                    track-by="label"
                    label="label"
                    v-model = "field.value"
                    v-bind = "field"
                    placeholder="Sélectionner le sous service"
                  />
                </Field>  
                <ErrorMessage name="categorieArticle" class="text-danger"/>
              </div>
            </div>
              <div class="col-md-4" >
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                  Icone
                  </label>
                  <Field name="urlImage" type="file" 
                        accept="image/jpeg, image/png"
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Choisir une icône"/>
                </div>
                <ErrorMessage name="urlImage" class="text-danger"/>
              </div>
              <!-- <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    isService
                  </label>
                  <Field  name="typeCategorie" v-model="typeDefault"  v-slot="{ field }">
                    <Multiselect
                      :options="typeServiceOptions"
                      :searchable="true"
                      track-by="label"
                      label="label"
                      v-model = "field.value"
                      v-bind = "field"
                      placeholder="Sélectionner"
                    />
                  </Field>  
                  <ErrorMessage name="typeCategorie" class="text-danger"/>
                </div>
              </div> -->

              <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Description<span class="text-danger">*</span>
                  </label>
                  <div class="mb-0">
                    <QuillEditor
                      ref="descriptionEditor"
                      theme="snow"
                      placeholder="Écrivez la description"
                      toolbar="full"
                      name="description"
                    />
                  </div>
                  <p class="text-danger" v-if="show === '1'">Ce champ est obligatoire</p>
                </div>
              </div>
             <div class="col-md-12">
               <div class="d-flex align-items-center ">
                 <button
                   class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                   type="submit" 
                 >
                     Ajouter
                 </button>
                 <router-link to="/liste-services" 
                     class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                     <span class="position-relative"></span>Annuler</router-link>
               </div>
         </div>
       </div>
     </Form>
   </div>
 </div>

  <div
      class="modal fade createNewModal"
      id="AddImageModal"
      tabindex="-1"
      ref="addAddImageModalRef"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25 ">
            <h5 class="modal-title fw-bold text-black"> Image actuelle</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25 text-center">
          <img :src="getUrlApiForFiles(categorie?.urlImage)" alt="Image" width="300" height="300" v-if="categorie?.urlImage">
            <h3 v-else>Aucune icône</h3>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
      </div>
    </div>
  
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive, computed } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { hideModal, getUrlApiForFiles } from '../../utils/utils';
import { CategorieArticle } from '../../models/CategorieArticle';
import { error , success } from '../../utils/utils';
import Multiselect from '@vueform/multiselect'
import axios from 'axios';
import { Categorie } from '@/models/Categorie';
import { useRoute, useRouter } from 'vue-router';

export default defineComponent({
    name: "AddService",
    components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }){
    const categorieArticleSchema = Yup.object().shape({
      urlImage: Yup.string().notRequired(),
      nom: Yup.string().required('Le nom est obligatoire'),
      description: Yup.string(),
      lienExterne: Yup.string().notRequired(),
      // lienExterne: Yup.string().when([], (value, schema) => {
      //   return estServiceExterne.value
      //     ? schema.required("Le lien externe est obligatoire")
      //     : schema.notRequired()
      // }),
      // isService: Yup.boolean().required('Le service est obligatoire'),
      typeCategorie:Yup.string().required('Le type est obligatoire'),
      categorieArticle: Yup.string().notRequired(),
    });

   
    const descriptionEditor= ref();
     const empty = ref("<p><br></p>")
    const categorieArticleForm = ref<CategorieArticle | null>(null);
    const addCategorieArticleModalRef = ref<null | HTMLElement>(null);
    const localItem = ref(props.item);
    const title = ref("Ajouter une catégorie d'article");
    const btntext = ref('Ajouter');
    const categorieOptions = ref([]);
    const route = useRoute();
    const router = useRouter();
    
    const typeDefault = ref("1")
    const typeCategorieOptions = [
    {
      label: 'Service interne',
      value: '0'
    },
    {
      label: 'Service externe',
      value: '1'
    }
  ];
  const typeServiceOptions = [
    {
      label: 'Non',
      value: '0'
    },
    {
      label: 'Oui',
      value: '1'
    }
  ];


  // const serviceOptions = [
  //   {
  //     label: 'Oui',
  //     value: true
  //   },
  //   {
  //     label: 'Non',
  //     value: false
  //   }
  // ];

  // const estServiceExterne = ref(false);

  //   const currentIsService = computed(() => {
  //     return estServiceExterne.value;
  //   });

  //   watch(estServiceExterne, (newValue) => {
  //     console.log('isService changed:', newValue);
  //   });
    const showA = ref(false)
    const show = ref("0")
    const onSubmit = () => {
      if(descriptionEditor.value.getHTML() !== empty.value) {
        showA.value = false;
        console.log('hijgrgrkjgmerjm')
      }
      else if(descriptionEditor.value.getHTML() === empty.value) {
        showA.value = true;
        show.value = "1"
      }
    }
    const addCategorieArticle = async (values: any) => {
      values = values as CategorieArticle

      if(values['typeCategorie'] == '0'){
        values['isService'] = "Oui";
      }else{
        values['isService'] = "Oui";
      }
        console.log('r,lgrg,lm', values['isService']);
        console.log("valeur avant soumission", values);

        values['description'] = descriptionEditor.value.getHTML();
        
        if(values['description'] !== empty.value) {
          showA.value = false;
        }
        else if(values['description'] === empty.value) {
          showA.value = true;
        }

        if(showA.value === false) {

          axios.post("/categorieArticles",values, { headers: { 'Content-Type': 'multipart/form-data','Accept': '*/*' } })
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
               router.push({ name: "ListeServicePage" });
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
        }
      
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      formFields.forEach(field => {
        field.value = '';
      });
    };

    const fetchCategorie = async () => {
      try {
        const response = await ApiService.get('/categorieArticles');
        const categorieData = response.data.data.data;
       const parentServices = categorieData.filter(
      (categorie: any) => categorie.isService === "Oui"
    );

    //Mapper les résultats filtrés pour ton <Multiselect>
    categorieOptions.value = parentServices.map((categorie: any) => ({
      value: categorie.id,
      label: `${categorie.nom}`,
    }));
      } catch (error) {
        //
      }
    };

    const showImage = async () => {
      console.log()
    }

    const categorie = ref<Categorie | null>(null);
    function getCategorie(id: string) {
      return ApiService.get("/categorieArticles/"+id.toString())
        .then(({ data }) => {
          categorie.value = data.data; 
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    } 

    onMounted(() => {
      fetchCategorie();
      // const id = route.params.id as string;
      // if(id){
      //   getCategorie(id);
      // }
    });

    return { categorieArticleSchema,
      onSubmit, descriptionEditor,
      showA, empty ,
      addCategorieArticleModalRef,
      categorie,getCategorie,
      addCategorieArticle,
      categorieArticleForm,
      title,btntext,resetValue, 
      categorieOptions,
      showImage,getUrlApiForFiles, show,
      route,typeCategorieOptions,typeServiceOptions,
      typeDefault,
    };
  },
});
</script>